"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logging = exports.tx = exports.u = exports.CONST = exports.wallet = exports.rpc = exports.sc = exports.settings = exports.nep5 = exports.api = void 0;
const neon_api_1 = __importDefault(require("@cityofzion/neon-api"));
const neonCore = __importStar(require("@cityofzion/neon-core"));
const neon_nep5_1 = __importDefault(require("@cityofzion/neon-nep5"));
const neonWithApi = neon_api_1.default(neonCore);
const neonJs = neon_nep5_1.default(neonWithApi);
exports.api = neonJs.api, exports.nep5 = neonJs.nep5, exports.settings = neonJs.settings, exports.sc = neonJs.sc, exports.rpc = neonJs.rpc, exports.wallet = neonJs.wallet, exports.CONST = neonJs.CONST, exports.u = neonJs.u, exports.tx = neonJs.tx, exports.logging = neonJs.logging;
const networks_1 = __importDefault(require("./networks"));
const bootstrap = networks_1.default;
Object.keys(bootstrap).map((key) => {
    exports.settings.networks[key] = new exports.rpc.Network(bootstrap[key]);
});
/**
 * Semantic path for creation of a resource.
 */
const create = {
    account: (k) => new exports.wallet.Account(k),
    privateKey: exports.wallet.generatePrivateKey,
    signature: exports.wallet.generateSignature,
    wallet: (k) => new exports.wallet.Wallet(k),
    claimTx: () => new exports.tx.ClaimTransaction(),
    contractTx: () => new exports.tx.ContractTransaction(),
    invocationTx: () => new exports.tx.InvocationTransaction(),
    stateTx: () => new exports.tx.StateTransaction(),
    contractParam: (type, value) => new exports.sc.ContractParam(type, value),
    script: exports.sc.createScript,
    scriptBuilder: () => new exports.sc.ScriptBuilder(),
    deployScript: (args) => exports.sc.generateDeployScript(args),
    rpcClient: (net, version) => new exports.rpc.RPCClient(net, version),
    query: (req) => new exports.rpc.Query(req),
    network: (net) => new exports.rpc.Network(net),
    stringStream: (str) => new exports.u.StringStream(str),
    fixed8: (i) => new exports.u.Fixed8(i),
};
/**
 * Semantic path for verification of a type.
 */
const is = {
    address: exports.wallet.isAddress,
    publicKey: exports.wallet.isPublicKey,
    encryptedKey: exports.wallet.isNEP2,
    privateKey: exports.wallet.isPrivateKey,
    wif: exports.wallet.isWIF,
    scriptHash: exports.wallet.isScriptHash,
};
/**
 * Semantic path for deserialization of object.
 */
const deserialize = {
    attribute: exports.tx.TransactionAttribute.deserialize,
    input: exports.tx.TransactionInput.deserialize,
    output: exports.tx.TransactionOutput.deserialize,
    script: exports.tx.Witness.deserialize,
    tx: exports.tx.Transaction.deserialize,
};
/**
 * Semantic path for signing using private key.
 */
const sign = {
    hex: exports.wallet.sign,
    message: (msg, privateKey) => {
        const hex = exports.u.str2hexstring(msg);
        return exports.wallet.sign(hex, privateKey);
    },
};
/**
 * Semantic path for verifying signatures using public key.
 */
const verify = {
    hex: exports.wallet.verify,
    message: (msg, sig, publicKey) => {
        const hex = exports.u.str2hexstring(msg);
        return exports.wallet.verify(hex, sig, publicKey);
    },
};
exports.default = {
    sendAsset: exports.api.sendAsset,
    claimGas: exports.api.claimGas,
    doInvoke: exports.api.doInvoke,
    setupVote: exports.api.setupVote,
    create,
    deserialize,
    is,
    sign,
    verify,
    encrypt: {
        privateKey: exports.wallet.encrypt,
    },
    decrypt: {
        privateKey: exports.wallet.decrypt,
    },
    add: {
        network: (network, override = false) => {
            if (override && exports.settings.networks[network.name]) {
                return false;
            }
            exports.settings.networks[network.name] = network;
            return true;
        },
    },
    remove: {
        network: (name) => {
            if (exports.settings.networks[name]) {
                delete exports.settings.networks[name];
                return true;
            }
            return false;
        },
    },
    u: exports.u,
    CONST: exports.CONST,
};
